import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IdentityApiService } from '../shared/services/identity-api.service';

@Component({
  selector: 'ins-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnInit {
  form!: FormGroup;
  submitted = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private identityApi: IdentityApiService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      userIdentifier: ['', Validators.required],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.controls['userIdentifier'].markAsTouched();
      return;
    }

    this.errorMessage = '';
    const identifier = this.form.value.userIdentifier.trim();

    this.identityApi.requestPasswordReset(identifier).subscribe({
      next: () => {
        this.submitted = true;
      },
      error: () => {
        // Show success regardless to avoid leaking whether the account exists
        this.submitted = true;
      },
    });
  }
}
